/** @module Specification/SharedSpecSectionsMatrixForLibMaterials */
define([
	"dojo/_base/declare",
	"SpecificationDataSheet/SharedSpecSectionsMatrix"
], function(
	declare,
	SharedSpecSectionsMatrix
) {
	return declare(SharedSpecSectionsMatrix, {
		columnPath: "Child:AllSharedSpecSectionsOnLibMaterial",

		/**
		 * @override
		 * Add any dependency paths necessary to process matrix
		 */
		addDependencyPaths: function(h, paths) {
			paths.push(
				"Child:AllSharedSpecSectionsOnLibMaterial/Child:SectionItems/Child:Definition/Child:ValueAttributeDefinition"
			);
			this.inherited(arguments);
		}
	});
});
